import {
  getPageContract,
  previewContract,
  querySignUrl,
  contractSignResult,
  contractPreSignQuery
} from '@/http/contract'

import { Toast } from 'vant'

const contractStore = {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    // 获取当前登录用户的合同列表
    fetchPageContract ({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPageContract(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '出错啦！')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 合同预览接口
    fetchPreviewContract ({ commit }, params) {
      return new Promise((resolve, reject) => {
        previewContract(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '出错啦！')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 签约地址列表查询接口
    fetchQuerySignUrl ({ commit }, params) {
      return new Promise((resolve, reject) => {
        querySignUrl(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '出错啦！')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 签署结果提交接口(所有签约方式共用)
    fetchContractSignResult ({ commit }, params) {
      return new Promise((resolve, reject) => {
        contractSignResult(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '出错啦！')
            resolve(res.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询当前合同签署所需要的参数、签约方式、条件和权限
    fetchContractPreSignQuery ({ commit }, params) {
      return new Promise((resolve, reject) => {
        contractPreSignQuery(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '出错啦！')
            resolve(res.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default contractStore



// WEBPACK FOOTER //
// ./src/views/contract/contractStore.js